import React from 'react'
import PropTypes from 'prop-types'

import CollapsibleSection from '../CollapsibleSection'
import FilesList from './Components/FilesList'

function FilesArea(props) {
  return (
    <div className="publisher-area publisher-area--files">
      <div className="card">
        <CollapsibleSection sectionSlug="files" trigger="Files">
          {props.files.length === 0 ? (
            <div className={`${props.showErrors ? 'text-warning' : ''}`}>Please upload at least one file format of your 3D model.</div>
          ) : (
            <FilesList
              key={`${props.files.length}-files-list`}
              itemId={props.itemId}
              itemStatus={props.itemStatus}
              files={props.files}
              fileTypes={props.fileTypes}
              onChange={props.onChange}
            />
          )}
        </CollapsibleSection>
      </div>
    </div>
  )
}

FilesArea.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemStatus: PropTypes.string.isRequired,
  files: PropTypes.array.isRequired,
  fileTypes: PropTypes.array.isRequired,
  showErrors: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default FilesArea
